import { pgTable, uuid, text, integer, real, boolean, timestamp, jsonb } from 'drizzle-orm/pg-core'
import { sql } from 'drizzle-orm'

export const tenants = pgTable('tenants', {
  id: uuid('id').primaryKey().default(sql`gen_random_uuid()`),
  name: text('name').notNull(),
  slug: text('slug').unique().notNull(),
  createdAt: timestamp('created_at', { withTimezone: true }).notNull().default(sql`now()`),
  updatedAt: timestamp('updated_at', { withTimezone: true }).notNull().default(sql`now()`),
})

export const tenantConfigs = pgTable('tenant_configs', {
  id: uuid('id').primaryKey().default(sql`gen_random_uuid()`),
  tenantId: uuid('tenant_id').notNull().references(() => tenants.id),

  // UI copy
  submissionPromptText: text('submission_prompt_text').notNull(),
  additionalInfoPromptText: text('additional_info_prompt_text').notNull(),
  submissionMaxChars: integer('submission_max_chars').notNull().default(4000),

  // Initial invite lists (seeded from YAML; runtime RBAC uses tenant_memberships)
  initialExpertInvites: text('initial_expert_invites').array().notNull().default(sql`'{}'`),
  initialDualAccessInvites: text('initial_dual_access_invites').array().notNull().default(sql`'{}'`),

  // AI behavior
  aiProvider: text('ai_provider').notNull().default('anthropic'),
  aiModel: text('ai_model').notNull().default('claude-sonnet-4-6'),
  aiTemperature: real('ai_temperature').notNull().default(0.3),
  minInfoScoreThreshold: real('min_info_score_threshold').notNull().default(0.7),
  maxClarificationCycles: integer('max_clarification_cycles').notNull().default(2),
  aiJobTimeoutSeconds: integer('ai_job_timeout_seconds').notNull().default(120),
  dataProcessingConsent: boolean('data_processing_consent').notNull().default(true),

  // Notification flags (per-tenant, previously YAML-only)
  includeResponseInEmail: boolean('include_response_in_email').notNull().default(true),
  expertDigestEnabled: boolean('expert_digest_enabled').notNull().default(true),

  // Intake config (per-tenant, previously YAML-only)
  categoryAbbreviations: jsonb('category_abbreviations')
    .$type<Record<string, string>>()
    .notNull()
    .default(sql`'{"Validation":"VAL","Equipment":"EQP","Compliance":"CMP","Deviation":"DEV","CAPA":"CAP","Other":"OTH"}'::jsonb`),

  createdAt: timestamp('created_at', { withTimezone: true }).notNull().default(sql`now()`),
  updatedAt: timestamp('updated_at', { withTimezone: true }).notNull().default(sql`now()`),
})
